import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cn } from '../cn';

export interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  block?: boolean;
}

/** Multi-line twin of the default TextInput: same border, background, radius and type size. */
export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(function TextArea({ block, className, rows = 3, ...rest }, ref) {
  return (
    <textarea
      ref={ref}
      rows={rows}
      className={cn('min-w-0 resize-y rounded-lg border border-border bg-bg2 px-2.5 py-2 text-md font-normal leading-[1.45] text-fg outline-none placeholder:text-fg5 disabled:opacity-50 md:rounded-md md:text-base', block && 'w-full', className)}
      {...rest}
    />
  );
});
